module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root,
    style: ({
      'background-image': 'url(' + _vm.src + ')'
    })
  }, [_c('img', {
    class: {
      "no-fit-cover": !_vm.hasObjectFitCover
    },
    attrs: {
      "src": _vm.src
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54ba1ba8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/image-helper/ImageHelper.vue
// module id = 2044
// module chunks = 1